import { render, staticRenderFns } from "./CollectionPaginationControls.vue?vue&type=template&id=845697b4&scoped=true&lang=pug&"
import script from "./CollectionPaginationControls.vue?vue&type=script&lang=js&"
export * from "./CollectionPaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPaginationControls.vue?vue&type=style&index=0&id=845697b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845697b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('845697b4')) {
      api.createRecord('845697b4', component.options)
    } else {
      api.reload('845697b4', component.options)
    }
    module.hot.accept("./CollectionPaginationControls.vue?vue&type=template&id=845697b4&scoped=true&lang=pug&", function () {
      api.rerender('845697b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionPaginationControls.vue"
export default component.exports